import type { DashboardSection } from '@library/api-customer-engagement-experience'

type HeroSection = Extract<
  DashboardSection,
  { type: 'unsubscribed_hero' | 'unsubscribed_hero_v2' | 'hero_card' }
>

export const selectHeroSection = (
  sections: DashboardSection[],
  isV2Enabled: boolean,
): HeroSection | null => {
  const heroCard = sections.find(
    (section): section is Extract<DashboardSection, { type: 'hero_card' }> =>
      section.type === 'hero_card',
  )
  // No client flag: the API only sends this hero to its target audience.
  if (heroCard) {
    return heroCard
  }

  const legacyHero = sections.find(
    (section): section is Extract<DashboardSection, { type: 'unsubscribed_hero' }> =>
      section.type === 'unsubscribed_hero',
  )
  const newHero = sections.find(
    (section): section is Extract<DashboardSection, { type: 'unsubscribed_hero_v2' }> =>
      section.type === 'unsubscribed_hero_v2',
  )

  if (legacyHero && newHero) {
    return isV2Enabled ? newHero : legacyHero
  }

  return newHero ?? legacyHero ?? null
}
